"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKEND_MESSAGES_SIGNALING_GUID = exports.BACKEND_SIGNALING_GUID = exports.DeviceDataSignalingEvent = exports.DataMessages = void 0;
exports.DataMessages = {
    FIELD_TYPE: "nucleusDataType",
    TYPE_MESSAGE: "message",
    TYPE_WEATHER: "weather",
    TYPE_DEVICE_INFO: "device",
    TYPE_ACCOUNT_INFO: "account",
    TYPE_PATIENT_INFO: "patient",
    TYPE_MEMORY_BOX_INFO: "memoryBox",
    TYPE_BULLETIN_INFO: "bulletin",
    TYPE_FAMILY_MEMBERS_INFO: "familyMembers",
    TYPE_NEED_TO_FETCH_DATA: "needToFetchData"
};
exports.DeviceDataSignalingEvent = {
    DeviceDataReceived: "onDeviceDataReceived",
    PatientDataReceived: "onPatientDataReceived",
    AccountDataReceived: "onAccountDataReceived",
    WeatherDataReceived: "onWeatherDataReceived",
    NeedToFetchData: "onNeedToFetchData"
};
exports.BACKEND_SIGNALING_GUID = '33A2D22D-5085-48DC-8C5A-F16BE7FA65DF'; // "backend"
exports.BACKEND_MESSAGES_SIGNALING_GUID = '5D26E9B6-BF9D-4672-A71A-880445237E9C'; // "nucleuscare-backend-messages"
